
import { getToken, removeToken } from '@/assets/utils/AuthUtil';

const user = {
  state: {
    token: getToken(),
    name: '',
    menu: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },

    SET_NAME: (state , name) => {
      state.name = name
    },

    SET_MENU: (state , menu) => {
      state.menu = menu
    }
  },

  actions: {
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '');
        commit('SET_NAME', []);

        removeToken();
        resolve();
      })
    }
  }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js